import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { id: "admin_user" }
const _hoisted_2 = { class: "row mb-3" }
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = { class: "row header smalltext align-items-center" }
const _hoisted_5 = { class: "col-3" }
const _hoisted_6 = { class: "col-3" }
const _hoisted_7 = { class: "col-2" }
const _hoisted_8 = { class: "col-2" }
const _hoisted_9 = { class: "col-1" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = {
  key: 0,
  class: "col-3"
}
const _hoisted_13 = {
  key: 1,
  class: "col-3"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", null, "<Kein Name>", -1)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = { class: "col-3 text-truncate" }
const _hoisted_17 = { class: "col-2 text-truncate" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { class: "col-2 text-truncate" }
const _hoisted_21 = { class: "col-1 text-align-center" }
const _hoisted_22 = { class: "col-1 text-align-right" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_26 = { key: 0 }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = { key: 0 }
const _hoisted_29 = { class: "row admin_user_row" }
const _hoisted_30 = { class: "col-6" }
const _hoisted_31 = { class: "col-6" }
const _hoisted_32 = { class: "col-6" }
const _hoisted_33 = {
  key: 0,
  class: "col-6"
}
const _hoisted_34 = { class: "col-6" }
const _hoisted_35 = { class: "col-6" }
const _hoisted_36 = { class: "col-12 mt-3" }
const _hoisted_37 = { class: "row" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 mb-2" }, "Führungskräfte dieses:r Mitarbeiters:in", -1)
const _hoisted_39 = { class: "col-12" }
const _hoisted_40 = { class: "col-12 mt-3" }
const _hoisted_41 = {
  key: 0,
  class: "row mt-3 admin_user_row"
}
const _hoisted_42 = { class: "col-12" }
const _hoisted_43 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_44 = /*#__PURE__*/_createElementVNode("p", null, "Active Directory Status: Eingeladen", -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("p", null, "Der User kann sich mit seinen Styria-Daten anmelden.", -1)
const _hoisted_46 = [
  _hoisted_44,
  _hoisted_45
]
const _hoisted_47 = {
  key: 1,
  class: "mb-3"
}
const _hoisted_48 = /*#__PURE__*/_createElementVNode("p", null, "Active Directory Status: Einladung versandt", -1)
const _hoisted_49 = /*#__PURE__*/_createElementVNode("p", null, "Der User muss die Einladung annehmen, und sich mit seinen Styria-Daten anmelden, um vom System freigeschalten zu werden.", -1)
const _hoisted_50 = {
  key: 2,
  class: "mb-3"
}
const _hoisted_51 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("Active Directory Status: "),
  /*#__PURE__*/_createElementVNode("span", null, "Einladung ausstehend")
], -1)
const _hoisted_52 = /*#__PURE__*/_createElementVNode("p", null, "Der User hat noch keinen Zugriff auf die Skillbase, erst nachdem er via Email eingeladen wurde kann er sich anmelden.", -1)
const _hoisted_53 = { class: "row mt-3 mb-2 admin_user_row" }
const _hoisted_54 = { class: "col-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalButton = _resolveComponent("ModalButton")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_Tooltip = _resolveComponent("Tooltip")!
  const _component_LabeledInput = _resolveComponent("LabeledInput")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_LabeledSelect = _resolveComponent("LabeledSelect")!
  const _component_AutoComplete = _resolveComponent("AutoComplete")!
  const _component_CheckBox = _resolveComponent("CheckBox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_ModalButton, {
          class: "newbutton",
          link: "admin_edit",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectUser()))
        }, {
          default: _withCtx(() => [
            _createElementVNode("button", null, _toDisplayString(_ctx.$t('management.new')), 1)
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('management.name')), 1),
      _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('management.login')), 1),
      _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('management.unit')), 1),
      _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('management.role')), 1),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_Tooltip, { text: "Active Directory (?)" }, {
          default: _withCtx(() => [
            _createVNode(_component_Icon, {
              width: 35,
              height: 35,
              path: _ctx.mdiEmailFast
            }, null, 8, ["path"]),
            _createTextVNode(" Einladung versandt"),
            _hoisted_10,
            _createVNode(_component_Icon, {
              width: 35,
              height: 35,
              path: _ctx.mdiAccountCheck
            }, null, 8, ["path"]),
            _createTextVNode(" Einladung angenommen"),
            _hoisted_11,
            _createVNode(_component_Icon, {
              class: "delete",
              width: 35,
              height: 35,
              path: _ctx.mdiAccountCancel
            }, null, 8, ["path"]),
            _createTextVNode(" Einladung ausstehend ")
          ]),
          _: 1
        })
      ])
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.users, (user) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "row userentry align-items-center",
        key: user.id
      }, [
        (user.lastname != '' || user.firstname != '')
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(user.lastname) + " " + _toDisplayString(user.firstname), 1))
          : (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_15)),
        _createElementVNode("div", _hoisted_16, _toDisplayString(user.username), 1),
        _createElementVNode("div", _hoisted_17, [
          (user.name == 'Keine Abteilung')
            ? (_openBlock(), _createElementBlock("i", _hoisted_18, "<" + _toDisplayString(user.name) + ">", 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(user.name), 1))
        ]),
        _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.getRoleByValue(user.rolename)?.label), 1),
        _createElementVNode("div", _hoisted_21, [
          (user.state == 'invited')
            ? (_openBlock(), _createBlock(_component_Icon, {
                key: 0,
                width: 35,
                height: 35,
                path: _ctx.mdiEmailFast
              }, null, 8, ["path"]))
            : (user.state == 'boarded')
              ? (_openBlock(), _createBlock(_component_Icon, {
                  key: 1,
                  width: 35,
                  height: 35,
                  path: _ctx.mdiAccountCheck
                }, null, 8, ["path"]))
              : (_openBlock(), _createBlock(_component_Icon, {
                  key: 2,
                  class: "delete",
                  width: 35,
                  height: 35,
                  path: _ctx.mdiAccountCancel
                }, null, 8, ["path"]))
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createVNode(_component_ModalButton, {
            link: "admin_edit",
            onClick: ($event: any) => (_ctx.selectUser(user.id))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Icon, {
                width: 35,
                height: 35,
                path: _ctx.mdiPencil,
                class: "hover"
              }, null, 8, ["path"])
            ]),
            _: 2
          }, 1032, ["onClick"]),
          _createVNode(_component_ModalButton, {
            link: `delete_unit_${user.id}`
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Icon, {
                width: 35,
                height: 35,
                path: _ctx.mdiDelete,
                class: "delete hover"
              }, null, 8, ["path"])
            ]),
            _: 2
          }, 1032, ["link"]),
          _createVNode(_component_Modal, {
            link: `delete_unit_${user.id}`,
            title: _ctx.$t('management.deleteunit_title', { unit: `${user.firstname} ${user.lastname}` }),
            onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.deleteName = ''))
          }, {
            default: _withCtx(() => [
              _createElementVNode("p", null, [
                _createTextVNode(_toDisplayString(_ctx.$t('management.usersadmin.grades')) + " Bitte bestätigen Sie durch Eingabe der vollständigen Email-Adresse.", 1),
                _hoisted_23,
                _hoisted_24,
                _createTextVNode(" " + _toDisplayString(user.email), 1),
                _hoisted_25,
                _createVNode(_component_LabeledInput, {
                  modelValue: _ctx.deleteName,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.deleteName) = $event))
                }, null, 8, ["modelValue"])
              ]),
              (_ctx.deleteName === `${user.email}`)
                ? (_openBlock(), _createElementBlock("p", _hoisted_26, [
                    _createElementVNode("button", {
                      onClick: ($event: any) => (_ctx.removeUser(user.id))
                    }, _toDisplayString(_ctx.$t('management.deleteconfirm')), 9, _hoisted_27)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1032, ["link", "title"])
        ])
      ]))
    }), 128)),
    (_ctx.users.length <= 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_28, _toDisplayString(_ctx.$t('app.loading')), 1))
      : _createCommentVNode("", true),
    (_ctx.selected)
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 1,
          link: "admin_edit",
          title: _ctx.selected.id ? `Bearbeite ${_ctx.selected.vorname} ${_ctx.selected.nachname}` : 'Neuer Benutzer',
          wide: ""
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, [
                _createVNode(_component_LabeledInput, {
                  label: _ctx.$t('management.firstname'),
                  modelValue: _ctx.selected.vorname,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selected.vorname) = $event))
                }, null, 8, ["label", "modelValue"])
              ]),
              _createElementVNode("div", _hoisted_31, [
                _createVNode(_component_LabeledInput, {
                  label: _ctx.$t('management.lastname'),
                  modelValue: _ctx.selected.nachname,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selected.nachname) = $event))
                }, null, 8, ["label", "modelValue"])
              ]),
              _createElementVNode("div", _hoisted_32, [
                _createVNode(_component_LabeledInput, {
                  label: _ctx.$t('management.email'),
                  modelValue: _ctx.selected.email,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selected.email) = $event))
                }, null, 8, ["label", "modelValue"])
              ]),
              (!_ctx.selected.id)
                ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                    _createVNode(_component_LabeledInput, {
                      label: _ctx.$t('management.email') + ' bestätigen',
                      modelValue: _ctx.selected.email2,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selected.email2) = $event))
                    }, null, 8, ["label", "modelValue"])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_34, [
                _createVNode(_component_LabeledSelect, {
                  label: _ctx.$t('management.unit'),
                  options: _ctx.unitoptions,
                  modelValue: _ctx.selected.unit_id,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.selected.unit_id) = $event))
                }, null, 8, ["label", "options", "modelValue"])
              ]),
              _createElementVNode("div", _hoisted_35, [
                _createVNode(_component_LabeledSelect, {
                  label: _ctx.$t('management.role'),
                  options: _ctx.roleoptions,
                  modelValue: _ctx.selected.role,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.selected.role) = $event))
                }, null, 8, ["label", "options", "modelValue"])
              ]),
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("div", _hoisted_37, [
                  _hoisted_38,
                  _createElementVNode("div", _hoisted_39, [
                    _createVNode(_component_AutoComplete, {
                      modelValue: _ctx.selected.managers,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.selected.managers) = $event)),
                      values: _ctx.managers
                    }, null, 8, ["modelValue", "values"])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_40, [
                _createVNode(_component_CheckBox, {
                  modelValue: _ctx.selected.leadership,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.selected.leadership) = $event)),
                  label: "Leadership Skills bei diesem User evaluieren"
                }, null, 8, ["modelValue"])
              ])
            ]),
            (_ctx.selected.id)
              ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                  _createElementVNode("div", _hoisted_42, [
                    (_ctx.selected.state == 'boarded')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_43, _hoisted_46))
                      : (_ctx.selected.state == 'invited')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                            _hoisted_48,
                            _hoisted_49,
                            _createElementVNode("span", {
                              class: "cta",
                              onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.invite(_ctx.selected.id)))
                            }, [
                              _createVNode(_component_Icon, {
                                width: 35,
                                height: 35,
                                path: _ctx.mdiEmailFast
                              }, null, 8, ["path"]),
                              _createTextVNode(" Einladung erneut versenden")
                            ])
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_50, [
                            _hoisted_51,
                            _hoisted_52,
                            _createElementVNode("span", {
                              class: "cta",
                              onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.invite(_ctx.selected.id)))
                            }, [
                              _createVNode(_component_Icon, {
                                width: 35,
                                height: 35,
                                path: _ctx.mdiEmailFast
                              }, null, 8, ["path"]),
                              _createTextVNode(" Einladung versenden")
                            ])
                          ]))
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_53, [
              _createElementVNode("div", _hoisted_54, [
                _createElementVNode("button", {
                  onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.saveUser())),
                  class: "button mt-3"
                }, _toDisplayString(_ctx.$t('management.save')), 1)
              ])
            ])
          ]),
          _: 1
        }, 8, ["title"]))
      : _createCommentVNode("", true)
  ]))
}